import MultiSelectBox from "./MultiSelectBox";
import { MultiSelectOption } from "./multiSelect-types";

/** 필터형의 최상단 액션 라벨. */
const ALL_LABEL = "전체";

type Props = {
  options: MultiSelectOption[];
  /** 선택된 조건. 빈 배열은 '조건 없음 = 전체 결과' 를 뜻합니다. */
  value: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  isDisabled?: boolean;
  className?: string;
};

/**
 * 조건 검색용 멀티셀렉트 (필터형).
 * 최상단 '전체' 는 선택지가 아니라 초기화 액션입니다.
 * 누르면 선택을 모두 지우고 레이어를 닫아 곧바로 전체 결과로 재검색되게 합니다.
 * 선택된 조건이 없으면 '전체' 를 비활성 처리합니다.
 */
const MultiSelectFilter = ({ options, value, onChange, placeholder, isDisabled, className }: Props) => {
  // 레거시 옵션 배열에는 value 가 '' 인 '전체' 항목이 섞여 있습니다.
  // 다른 컴포넌트와 공유되는 배열이라 정의를 고치지 않고 여기서 걸러냅니다.
  const selectableOptions = options.filter((option) => option.value !== "");
  const selectedValues = value.filter((selected) => selected !== "");

  const displayText = selectableOptions
    .filter((option) => selectedValues.includes(option.value))
    .map((option) => option.label)
    .join(", ");

  const onToggleOption = (target: string) => {
    const nextValues = selectedValues.includes(target) ? selectedValues.filter((selected) => selected !== target) : [...selectedValues, target];
    onChange(nextValues);
  };

  return (
    <MultiSelectBox
      options={selectableOptions}
      selectedValues={selectedValues}
      onToggleOption={onToggleOption}
      headerActions={[
        {
          label: ALL_LABEL,
          onClick: () => onChange([]),
          isDisabled: selectedValues.length === 0,
          closeOnClick: true,
        },
      ]}
      displayText={displayText}
      placeholder={placeholder}
      isDisabled={isDisabled}
      className={className}
    />
  );
};

export default MultiSelectFilter;
